import axios from 'axios'
import { getAuthHeaders } from '../api/auth'

export const fetchProjects = (cb) => async (dispatch, getState) => {
  if (getState().projects.loaded) return
  dispatch({ type: 'FETCH_PROJECTS_REQUEST' })
  try {
    let { data } = await axios({
      method: 'get',
      url: '/api/projects',
      headers: getAuthHeaders(),
    })
    dispatch({ type: 'FETCH_PROJECTS_SUCCESS', data })
  } catch (error) {
    console.log(error)
    cb(error)
  }
}

export const createProject = (values, cb) => async (dispatch, getState) => {
  try {
    let { data } = await axios({
      method: 'post',
      url: '/api/projects',
      headers: getAuthHeaders(),
      data: values,
    })
    dispatch({ type: 'NEW_PROJECT_SUCCESS', data })
  } catch (error) {
    console.log(error)
    cb(error)
  }
}

const initialState = {
  loaded: false,
  loading: false,
  items: [],
}

export default function handleProjects(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_PROJECTS_REQUEST':
      return {
        ...state,
        loading: true,
      }
    case 'FETCH_PROJECTS_SUCCESS':
      return {
        ...state,
        items: action.data,
        loading: false,
        loaded: true,
      }
    case 'NEW_PROJECT_SUCCESS':
      return {
        ...state,
        items: [...state.items, action.data],
      }
    default:
      return state
  }
}
